import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowUpRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowUpRight"><Path d="M18.5 15.5V5.5H8.5" stroke="currentColor" strokeLinecap="square"/><Path d="M18 6L6 18" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowUpRight;
